module.exports = __webpack_public_path__ + "src/img/liuchengjiankong.4fc2c5c2.svg";